import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    Button,
    Col, Form,
    FormGroup,
    Input,
    Label,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Row
} from 'reactstrap';
import { AvFeedback, AvField, AvForm, AvGroup, AvInput } from 'availity-reactstrap-validation';
import moment from 'moment';
import MaterialIcon from 'material-icons-react';
import i18n from '../../../i18next';

import { getCurrencySymbol } from '../../../utils/CommonUtils';
import { getCroppedImg, createFileFromBase64ImageData } from '../../../utils/CropImageUtils';
import { FRONT_END_URL, MENUU_ADMIN, MENUU_MASTER_ADMIN } from '../../../utils/Constants';
import {
    getLoyalty,
    loadRestaurantSettings,
    saveLoyalty,
    uploadPromotionImage,
    deleteLoyalty,
    deleteLoyaltyImage,
    dispatchErrorMessage
} from '../../../actions';
import LoyaltyUsers from './LoyaltyUsers';
import CropImageModal from '../../common/CropImageModal';
import CommonMessage from '../customerInsightScreen/CommonMessage';

class LoyaltyScreen extends Component {
    constructor(props) {
        super(props);

        this.state = {
            modal: false,
            modalAction: null,
            orderTypes: null,
            supportedOrderTypes: null,
            collection: null,
            delivery: null,
            dinein: null,
            curbside: null,
            startDateInputValue: false,
            endDateInputValue: false,
            cropLoyaltyImageModalOpened: false,
            loyaltyImageBase64: null,
            imageExtension: null,
            loyaltyForm: {
                id: -1,
                priceDiscount: {
                    id: -1,
                    discountValue: 0
                },
                name: "",
                description: "",
                conditionType: "MINIMUM_ORDER_AMOUNT",
                conditionValue: 0,
                averageValueDiscount: true,
                orderCount: 0,
                validity: {
                    startDate: "",
                    endDate: "",
                    validOnMonday: true,
                    validOnTuesday: true,
                    validOnWednesday: true,
                    validOnThursday: true,
                    validOnFriday: true,
                    validOnSaturday: true,
                    validOnSunday: true
                },
                orderTypes: [
                    {
                        id: 1,
                        value: "Delivery"
                    },
                    {
                        id: 2,
                        value: "Collection"
                    },
                    {
                        id: 4,
                        value: 'Curbside'
                    },
                    {
                        id: 5,
                        value: 'In Store'
                    }
                ],
                promoCodeValidity: 0,
                loyaltyPromotion: true,
                activeLoyalty: false,
                imagePath: null,
                imagePreview: null,
                formData: null
            },
            isMenuuAdminOrMasterAdmin: false
        };
    }

    componentDidMount() {
        let restaurantId = this.props.match.params.id;
        const { user } = this.props;
        this.props.loadRestaurantSettings(restaurantId);
        this.props.getLoyalty(restaurantId);

        this.setState({
            isMenuuAdminOrMasterAdmin: user.role === MENUU_ADMIN || user.role === MENUU_MASTER_ADMIN ? true : false
        })
    }

    componentDidUpdate(prevProps) {
        if (prevProps.supportedOrderTypes !== this.props.supportedOrderTypes) {
            if (this.props.supportedOrderTypes !== null && this.props.supportedOrderTypes !== undefined) {

                let collection = null;
                let delivery = null;
                let dinein = null;
                let curbside = null;
                let inStore = null;
                collection = this.orderTypeSupported('Collection');
                delivery = this.orderTypeSupported('Delivery');
                dinein = this.orderTypeSupported('Dine In');
                curbside = this.orderTypeSupported('Curbside');
                inStore = this.orderTypeSupported('In Store')

                this.setState({
                    ...this.state,
                    orderTypes: this.props.orderTypes ? this.props.orderTypes : [],
                    supportedOrderTypes: this.props.supportedOrderTypes,
                    collection: this.props.orderTypes ? collection : true,
                    delivery: this.props.orderTypes ? delivery : true,
                    dinein: this.props.orderTypes ? dinein : true,
                    curbside: this.props.orderTypes ? curbside : true
                });

            }
        }

        if (prevProps.loyalty !== this.props.loyalty) {
            if (this.props.loyalty) {
                const dbLoyalty = this.props.loyalty;
                this.setState({
                    ...this.state,
                    startDateInputValue: moment(dbLoyalty.validity.startDate, 'DD-MM-YYYY').format('YYYY-MM-DD'),
                    endDateInputValue: moment(dbLoyalty.validity.endDate, 'DD-MM-YYYY').format('YYYY-MM-DD'),
                    loyaltyForm: {
                        ...this.state.loyaltyForm,
                        id: dbLoyalty.id,
                        priceDiscount: {
                            id: dbLoyalty.priceDiscount.id,
                            discountValue: dbLoyalty.priceDiscount.discountValue
                        },
                        name: dbLoyalty.name,
                        description: dbLoyalty.description,
                        conditionValue: dbLoyalty.conditionValue,
                        averageValueDiscount: dbLoyalty.averageValueDiscount,
                        orderCount: dbLoyalty.orderCount,
                        validity: {
                            ...this.state.loyaltyForm.validity,
                            startDate: dbLoyalty.validity.startDate,
                            endDate: dbLoyalty.validity.endDate
                        },
                        imagePath: dbLoyalty.imagePath,
                        orderTypes: dbLoyalty.orderTypes,
                        promoCodeValidity: dbLoyalty.promoCodeValidity,
                        activeLoyalty: dbLoyalty.activeLoyalty
                    }
                });
            }
        }
    }

    handleSubmit = () => {
        this.setState({
            ...this.state,
            modal: false
        });

        this.props.saveLoyalty(this.props.match.params.id, { ...this.state.loyaltyForm }, () => {
            setTimeout(() => {
                this.props.getLoyalty(this.props.match.params.id);
            }, 1000);

        });
    };

    handleDelete = () => {
        this.props.deleteLoyalty(this.state.loyaltyForm.id);

        this.setState({
            ...this.state,
            modal: false,
            startDateInputValue: "",
            endDateInputValue: "",
            loyaltyForm: {
                id: -1,
                priceDiscount: {
                    id: -1,
                    discountValue: 0
                },
                name: "",
                description: "",
                conditionType: "MINIMUM_ORDER_AMOUNT",
                conditionValue: 0,
                orderCount: 0,
                validity: {
                    startDate: "",
                    endDate: "",
                    validOnMonday: true,
                    validOnTuesday: true,
                    validOnWednesday: true,
                    validOnThursday: true,
                    validOnFriday: true,
                    validOnSaturday: true,
                    validOnSunday: true
                },
                orderTypes: [
                    {
                        id: 1,
                        value: "Delivery"
                    },
                    {
                        id: 2,
                        value: "Collection"
                    }
                ],
                promoCodeValidity: 0,
                loyaltyPromotion: true,
                activeLoyalty: false,
                imagePath: null,
                imagePreview: null,
                formData: null
            }
        });
    };

    handleImageDelete = () => {
        if (this.state.loyaltyForm.imagePath) {
            this.props.deleteLoyaltyImage(this.state.loyaltyForm.id);
        }

        this.setState({
            ...this.state,
            modal: false,
            loyaltyForm: {
                ...this.state.loyaltyForm,
                imagePath: null,
                imagePreview: null,
                formData: null
            }
        });
    };

    uploadImage(event) {
        event.preventDefault();
        const file = event.target.files[0];

        if (file.size > 512000) {
            this.props.dispatchErrorMessage(`${i18n.t('common:validations.maximumImageSize')} 512KB`)
        } else {
            if (file !== undefined) {                           // file === undefined when you click cancel
                this.setState({
                    ...this.state,
                    loyaltyForm: {
                        ...this.state.loyaltyForm,
                        imagePreview: URL.createObjectURL(file),
                        formData: event.target.files[0]
                    }
                });

                //this is for crop image
                let reader = new FileReader();

                reader.onloadend = () => {
                    this.setState({
                        ...this.state,
                        loyaltyImageBase64: reader.result,
                        imageExtension: file.type
                    }, () => this.toggleLoyaltyImageCropModal());
                };
                reader.readAsDataURL(file);
            }
        }
    }

    toggleLoyaltyImageCropModal = () => {
        this.setState({
            ...this.state,
            cropLoyaltyImageModalOpened: !this.state.cropLoyaltyImageModalOpened
        });
    }

    onCropLoyaltyImageUpload = async (crop) => {
        try {
            const imageData = await getCroppedImg(crop.image, crop.croppedAreaPixels, 0, this.state.imageExtension);
            const blobData = createFileFromBase64ImageData(imageData, this.state.imageExtension);
            const uploadImageExtension = this.state.imageExtension.split('/')[1];
            const imageFile = new File([blobData], `loyaltyImage.${uploadImageExtension}`, { type: blobData.type });

            this.setState({
                ...this.state,
                loyaltyForm: {
                    ...this.state.loyaltyForm,
                    imagePreview: imageData,
                    formData: imageFile
                }
            }, () => this.toggleLoyaltyImageCropModal());
        } catch (e) {
            console.error(e);
        }
    }

    orderTypeSupported(orderType) {
        if (this.props.orderTypes) {
            let option = this.props.orderTypes.map((option) => {
                if (option.value === orderType) {
                    return true
                }
            })
                .filter((val) => {
                    if (val !== undefined) {
                        return val
                    }
                })[0];

            return !!option;
        } else {
            return null;
        }
    }

    changeState = ({ target }) => {
        this.setState({
            ...this.state,
            loyaltyForm: {
                ...this.state.loyaltyForm,
                [target.name]: target.value
            }
        });
    };

    changeBooleanRadioButtonsState = ({ target }) => {
        this.setState({
            ...this.state,
            loyaltyForm: {
                ...this.state.loyaltyForm,
                [target.name]: !!(target.value === 'true')
            }
        });
    };

    changeDiscountState = ({ target }) => {
        this.setState({
            ...this.state,
            loyaltyForm: {
                ...this.state.loyaltyForm,
                priceDiscount: {
                    ...this.state.loyaltyForm.priceDiscount,
                    [target.name]: target.value
                }
            }
        });
    };

    changeDateRange = ({ target }) => {
        this.setState({
            ...this.state,
            [target.name + 'InputValue']: target.value,
            loyaltyForm: {
                ...this.state.loyaltyForm,
                validity: {
                    ...this.state.loyaltyForm.validity,
                    [target.name]: moment(target.value, 'YYYY-MM-DD').format('DD-MM-YYYY')
                }
            }
        });
    };

    updateCheckboxState = ({ target }) => {
        if (target.value === 'true') {
            this.setState({
                ...this.state,
                loyaltyForm: {
                    ...this.state.loyaltyForm,
                    [target.name]: false
                }
            });
        } else {
            this.setState({
                ...this.state,
                loyaltyForm: {
                    ...this.state.loyaltyForm,
                    [target.name]: true
                }
            });
        }
    };

    updateDeliveryOptionState = ({ target }) => {
        const deliveryOption = { id: 1, value: "Delivery" };
        const collectionOption = { id: 2, value: "Collection" };
        const curbsideOption = { id: 4, value: 'Curbside' };
        const instoreOption = { id: 5, value: 'In Store ' };

        switch (target.name) {
            case "Delivery":
                if (target.value === 'true') {
                    this.setState({
                        ...this.state,
                        loyaltyForm: {
                            ...this.state.loyaltyForm,
                            orderTypes: this.state.loyaltyForm.orderTypes.filter(typeOption => typeOption.id !== deliveryOption.id)
                        }
                    });
                } else {
                    this.setState({
                        ...this.state,
                        loyaltyForm: {
                            ...this.state.loyaltyForm,
                            orderTypes: [
                                ...this.state.loyaltyForm.orderTypes,
                                deliveryOption
                            ]
                        }
                    });
                }
                break;
            case "Collection":
                if (target.value === 'true') {
                    this.setState({
                        ...this.state,
                        loyaltyForm: {
                            ...this.state.loyaltyForm,
                            orderTypes: this.state.loyaltyForm.orderTypes.filter(typeOption => typeOption.id !== collectionOption.id)
                        }
                    });
                } else {
                    this.setState({
                        ...this.state,
                        loyaltyForm: {
                            ...this.state.loyaltyForm,
                            orderTypes: [
                                ...this.state.loyaltyForm.orderTypes,
                                collectionOption
                            ]
                        }
                    });
                }
                break;
            case 'Curbside':
                if (target.value === 'true') {
                    this.setState({
                        ...this.state,
                        loyaltyForm: {
                            ...this.state.loyaltyForm,
                            orderTypes: this.state.loyaltyForm.orderTypes.filter(typeOption => typeOption.id !== curbsideOption.id)
                        }
                    });
                } else {
                    this.setState({
                        ...this.state,
                        loyaltyForm: {
                            ...this.state.loyaltyForm,
                            orderTypes: [
                                ...this.state.loyaltyForm.orderTypes,
                                curbsideOption
                            ]
                        }
                    });
                }
                break;
            case "In Store":
                if (target.value === 'true') {
                    this.setState({
                        ...this.state,
                        loyaltyForm: {
                            ...this.state.loyaltyForm,
                            orderTypes: this.state.loyaltyForm.orderTypes.filter(typeOption => typeOption.id !== instoreOption.id)
                        }
                    });
                } else {
                    this.setState({
                        ...this.state,
                        loyaltyForm: {
                            ...this.state.loyaltyForm,
                            orderTypes: [
                                ...this.state.loyaltyForm.orderTypes,
                                instoreOption
                            ]
                        }
                    });
                }
                break;
            default:
                break;
        }
    };

    negativeDecimalsValidation(e) {
        let inputKeyCode = e.keyCode ? e.keyCode : e.which;

        if (inputKeyCode != null) {
            if (inputKeyCode == 43 || inputKeyCode == 45 || inputKeyCode == 69
                || inputKeyCode == 101) e.preventDefault();
        }
    }

    renderHeading(iconName, label) {
        const { screenHeading } = styles;

        return (
            <div style={screenHeading}>
                <MaterialIcon icon={iconName} color="#0288d1" size={22} />&nbsp;
                {label}
            </div>
        );
    }

    renderLoyaltyNameAndDescription() {
        const { textArea, restaurantFieldGroups, fieldLabel, fieldStyle } = styles;
        return (
            <React.Fragment>
                <AvGroup style={restaurantFieldGroups}>
                    <Label for="name" style={fieldLabel}>{i18n.t('screens:loyaltyScreen.loyaltyName')}</Label>
                    <AvInput type="text" name="name" id="restaurantName" placeholder={i18n.t('common:form.name')}
                        style={fieldStyle}
                        value={this.state.loyaltyForm.name}
                        onChange={this.changeState}
                        required
                        disabled={!this.state.isMenuuAdminOrMasterAdmin}
                    />
                    <AvFeedback>{i18n.t('common:validations.errorMsg')}</AvFeedback>
                </AvGroup>
                <AvGroup>
                    <AvField type="textarea" name="description" label={i18n.t('common:form.description')}
                        value={this.state.loyaltyForm.description}
                        style={textArea}
                        onChange={this.changeState}
                        required
                        errorMessage={i18n.t('common:validations.errorMsg')}
                        disabled={!this.state.isMenuuAdminOrMasterAdmin}
                    />
                    <AvFeedback>{i18n.t('common:validations.errorMsg')}</AvFeedback>
                </AvGroup>
            </React.Fragment>
        );
    }

    renderActiveLoyalty() {

        return (
            <FormGroup check inline>
                <Label check style={styles.checkboxesLabel}>{i18n.t('common:buttons.active')}</Label>
                <Input
                    type="checkbox"
                    name="activeLoyalty"
                    checked={this.state.loyaltyForm.activeLoyalty}
                    value={this.state.loyaltyForm.activeLoyalty}
                    onChange={this.updateCheckboxState}
                    disabled={!this.state.isMenuuAdminOrMasterAdmin}
                />
            </FormGroup>
        );
    }

    renderDatePickers() {

        return (
            <React.Fragment>
                <Row>
                    <Col sm={6}>
                        <AvGroup row>
                            <Label for="startDate" style={styles.fromDatePickerLabel}
                                sm={3}>{i18n.t('screens:promotionValidityScreen.datePickerFrom')}</Label>
                            <Col sm={9}>
                                <AvInput
                                    type="date"
                                    name="startDate"
                                    id="startDate"
                                    placeholder="datetime placeholder"
                                    required
                                    value={this.state.startDateInputValue}
                                    onChange={this.changeDateRange}
                                    disabled={!this.state.isMenuuAdminOrMasterAdmin}
                                />
                                <AvFeedback>{i18n.t('screens:loyaltyScreen.emptyFieldErrMsg')}</AvFeedback>
                            </Col>
                        </AvGroup>
                    </Col>
                    <Col sm={6}>
                        <AvGroup row>
                            <Label for="endDate" style={styles.toDatePickerLabel}
                                sm={3}>{i18n.t('screens:promotionValidityScreen.datePickerTo')}</Label>
                            <Col sm={9}>
                                <AvInput
                                    type="date"
                                    name="endDate"
                                    id="endDate"
                                    placeholder="datetime placeholder"
                                    required
                                    value={this.state.endDateInputValue}
                                    onChange={this.changeDateRange}
                                    disabled={!this.state.isMenuuAdminOrMasterAdmin}
                                />
                                <AvFeedback>{i18n.t('screens:loyaltyScreen.emptyFieldErrMsg')}</AvFeedback>
                            </Col>
                        </AvGroup>
                    </Col>
                </Row>
            </React.Fragment>
        );
    }

    renderAmountAndValue() {
        const currencyType = getCurrencySymbol(this.props.restaurant.currency);
        const { restaurantFieldGroups, fieldLabel, fieldStyle, currencyTypeStyle, priceInput, priceInputField } = styles;

        return (
            <Row>
                <Col sm={4}>
                    <AvGroup style={restaurantFieldGroups}>
                        <Label for="name" style={fieldLabel}>{i18n.t('screens:loyaltyScreen.numberOfOrders')}</Label>
                        <AvInput type="number" name="orderCount" id="restaurantName"
                            placeholder={i18n.t('screens:loyaltyScreen.numberOfOrders')}
                            style={fieldStyle}
                            value={this.state.loyaltyForm.orderCount}
                            onChange={this.changeState}
                            min={2} onKeyPress={(e) => this.negativeDecimalsValidation(e)}
                            required
                            disabled={!this.state.isMenuuAdminOrMasterAdmin}
                        />
                        <AvFeedback>{this.state.loyaltyForm.orderCount < 2 ? i18n.t('screens:loyaltyScreen.minOrderCount') : i18n.t('common:validations.errorMsg')}</AvFeedback>
                    </AvGroup>
                </Col>
                <Col sm={4}>
                    <AvGroup style={restaurantFieldGroups}>
                        <Label for="name"
                            style={fieldLabel}>{i18n.t('screens:loyaltyScreen.minimumOrderAmount')}</Label>
                        <div style={priceInput}>
                            <AvInput type="number" name="conditionValue" id="restaurantName"
                                placeholder={i18n.t('screens:loyaltyScreen.amount')}
                                style={priceInputField}
                                value={this.state.loyaltyForm.conditionValue}
                                onChange={this.changeState}
                                min={0} onKeyPress={(e) => this.negativeDecimalsValidation(e)}
                                required
                                disabled={!this.state.isMenuuAdminOrMasterAdmin}
                            />
                            <Label style={currencyTypeStyle}>{currencyType}</Label>
                            <AvFeedback>{i18n.t('common:validations.errorMsg')}</AvFeedback>
                        </div>
                    </AvGroup>
                </Col>
            </Row>
        );
    }

    renderLoyaltyImage() {
        const { imagePreview, imagePath } = this.state.loyaltyForm;
        const { figure, deleteButton } = styles;
        let imageSrc;
        let labelStyle;
        let imgStyle;

        if (imagePreview !== null && imagePreview !== undefined) {
            imageSrc = imagePreview;
            labelStyle = '';
            imgStyle = { width: '100%', height: '100%', objectFit: 'cover', zIndex: 1 };
        } else if (imagePath === null) {
            imageSrc = imagePreview;
            labelStyle = 'coloured-label';
            imgStyle = { height: '100%', objectFit: 'cover', zIndex: 1 };
        } else {
            imageSrc = `${FRONT_END_URL}/${imagePath}`;
            labelStyle = '';
            imgStyle = { width: '100%', height: '100%', objectFit: 'cover', zIndex: 1 }
        }

        return (
            <div>
                <figure style={figure}>
                    {
                        (this.state.loyaltyForm.imagePath || this.state.loyaltyForm.imagePreview) && this.state.isMenuuAdminOrMasterAdmin ?
                            <div style={deleteButton} onClick={this.toggleLoyaltyImageDeleteModal}><MaterialIcon
                                icon="delete_outline" color="#cdcdcd" size={26} /></div> :
                            null
                    }
                    <input id="imagePreview" value={''} className="custom-file-input" type="file" name="imagePreview"
                        disabled={!this.state.isMenuuAdminOrMasterAdmin}
                        onChange={(event) => this.uploadImage(event)} />
                    {
                        this.state.isMenuuAdminOrMasterAdmin ?
                        <label style={{ width: '150px', left: 'auto', transform: 'none', textAlign: 'center', pointerEvents: this.state.isMenuuAdminOrMasterAdmin ? 'auto' : 'none' }} htmlFor="imagePreview">
                            <div style={{ display: 'flex', flexFlow: 'row wrap', justifyContent: 'center' }}>
                                <span><MaterialIcon icon="local_see" size={30} /></span>
                                {i18n.t('common:buttons.fileUpload')}
                                <div style={{ fontSize: 12 }}>({i18n.t('screens:promotionImageScreen.specs')})</div>
                            </div>
                        </label> : null
                    }
                    <img style={imgStyle} src={imageSrc} />
                </figure>
            </div>
        );
    }

    renderPromoCodeValidity() {
        const currencyType = getCurrencySymbol(this.props.restaurant.currency);
        const { radioBtnLabel, radioButtonsContainer, restaurantFieldGroups, fieldLabel, currencyTypeStyle, priceInput, priceInputField } = styles;

        return (
            <React.Fragment>
                <Row>
                    <Col sm={12} md={12} lg={8}>
                        <AvGroup style={restaurantFieldGroups}>
                            <Form inline name="averageValueDiscount" style={radioButtonsContainer}>
                                <Input type="radio" name="averageValueDiscount" value={true}
                                    checked={this.state.loyaltyForm.averageValueDiscount === true}
                                    onChange={this.changeBooleanRadioButtonsState}
                                    disabled={!this.state.isMenuuAdminOrMasterAdmin}
                                />
                                <Label style={radioBtnLabel} for="priceDiscount">{i18n.t('screens:loyaltyScreen.averageOrderAmount')}</Label>

                                <Input type="radio" name="averageValueDiscount" value={false}
                                    checked={this.state.loyaltyForm.averageValueDiscount === false}
                                    onChange={this.changeBooleanRadioButtonsState}
                                    disabled={!this.state.isMenuuAdminOrMasterAdmin}
                                />
                                <Label style={radioBtnLabel} for="freeProduct">{i18n.t('screens:loyaltyScreen.fixedValue')}</Label>
                            </Form>
                            <div style={priceInput}>
                                <AvInput type="number" name="discountValue" id="restaurantName"
                                    placeholder={i18n.t('screens:loyaltyScreen.value')}
                                    style={priceInputField}
                                    value={this.state.loyaltyForm.priceDiscount.discountValue}
                                    onChange={this.changeDiscountState}
                                    min={0} onKeyPress={(e) => this.negativeDecimalsValidation(e)}
                                    disabled={this.state.loyaltyForm.averageValueDiscount || !this.state.isMenuuAdminOrMasterAdmin}
                                    required={!this.state.loyaltyForm.averageValueDiscount}
                                />
                                <Label style={currencyTypeStyle}>{currencyType}</Label>
                                <AvFeedback>{i18n.t('common:validations.errorMsg')}</AvFeedback>
                            </div>
                        </AvGroup>
                    </Col>
                    <Col sm={12} md={12} lg={4}>
                        <AvGroup style={restaurantFieldGroups}>
                            <Label for="value"
                                style={fieldLabel}>{i18n.t('screens:loyaltyScreen.promoCodeValidity')}</Label>
                            <div style={priceInput}>
                                <AvInput type="number" name="promoCodeValidity"
                                    style={priceInputField}
                                    value={this.state.loyaltyForm.promoCodeValidity}
                                    onChange={this.changeState}
                                    min={0} onKeyPress={(e) => this.negativeDecimalsValidation(e)}
                                    required
                                    disabled={!this.state.isMenuuAdminOrMasterAdmin}
                                />
                                <Label style={currencyTypeStyle}>{i18n.t('screens:loyaltyScreen.days')}</Label>
                                <AvFeedback>{i18n.t('common:validations.errorMsg')}</AvFeedback>
                            </div>
                        </AvGroup>
                    </Col>
                </Row>
            </React.Fragment>
        );
    }

    renderDeliveryOptions() {
        if (this.state.supportedOrderTypes) {
            let deliveryOptions = this.state.supportedOrderTypes.map((option, optionIndex) => {
                let checked = false;
                this.state.loyaltyForm.orderTypes.map(orderType => {

                    if (orderType.id === option.id) {
                        checked = true;
                    }
                });

                let labelValue = '';
                if (option.value === 'Collection') {
                    labelValue = i18n.t('screens:loyaltyScreen.pickUp');
                } else if (option.value === 'In Store') {
                    labelValue = i18n.t('screens:loyaltyScreen.dinePay');
                } else if (option.value === 'Curbside') {
                    labelValue = i18n.t('screens:restaurantsMainContainer.curbside');
                } else if (option.value === 'Delivery') {
                    labelValue = i18n.t('screens:restaurantsMainContainer.delivery');
                } else {
                    labelValue = option.value;
                }

                return (
                    <FormGroup key={`optionLoyalty${optionIndex}`} check inline>
                        <Label check style={styles.checkboxesLabel}>{labelValue} </Label>
                        <Input
                            type="checkbox"
                            name={option.value}
                            checked={checked}
                            value={checked}
                            onChange={this.updateDeliveryOptionState}
                            disabled={!this.state.isMenuuAdminOrMasterAdmin}
                        />
                    </FormGroup>
                );
            });

            return (
                <div style={styles.checkboxesContainer}>
                    {deliveryOptions}
                </div>
            );
        } else {
            return null;
        }
    }

    toggleModal = () => {
        this.setState({
            ...this.state,
            modal: !this.state.modal
        });
    };

    renderModal() {
        let headerText;
        let bodyText;
        let confirmButtonFunction;

        switch (this.state.modalAction) {
            case 'SAVE':
                headerText = i18n.t('screens:loyaltyScreen.saveModalHeader');
                bodyText = i18n.t('screens:loyaltyScreen.saveModalBody');
                confirmButtonFunction = this.handleSubmit;
                break;
            case 'DELETE':
                headerText = i18n.t('screens:loyaltyScreen.deleteModalHeader');
                bodyText = i18n.t('screens:loyaltyScreen.deleteModalBody');
                confirmButtonFunction = this.handleDelete;
                break;
            case 'DELETE_IMAGE':
                headerText = i18n.t('screens:loyaltyScreen.deleteImageModalHeader');
                bodyText = i18n.t('screens:loyaltyScreen.deleteImageModalBody');
                confirmButtonFunction = this.handleImageDelete;
                break;
            default:
                break;
        }

        return (
            <Modal isOpen={this.state.modal} toggle={this.toggleModal}>
                <ModalHeader className="modalHeader" toggle={this.toggleModal}>
                    {headerText}
                </ModalHeader>
                <ModalBody>
                    {bodyText}
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={confirmButtonFunction}><MaterialIcon icon="check" color="#fff"
                        size={20} />&nbsp;{i18n.t('common:buttons.confirm')}</Button>{' '}
                    <Button color="outline-primary" onClick={this.toggleModal}>{i18n.t('common:buttons.cancel')}</Button>
                </ModalFooter>
            </Modal>
        );
    }

    toggleLoyaltyUpdateModal = () => {
        this.setState({
            ...this.state,
            modal: true,
            modalAction: 'SAVE'
        });
    };

    toggleLoyaltyDeleteModal = () => {
        this.setState({
            ...this.state,
            modal: true,
            modalAction: 'DELETE'
        });
    };

    toggleLoyaltyImageDeleteModal = () => {
        this.setState({
            ...this.state,
            modal: true,
            modalAction: 'DELETE_IMAGE'
        });
    };

    render() {
        const { containerStyle, buttons, spaceBetween } = styles;
        if(this.props.loyaltyErrorResponse.isLoyaltyNotFound) {
            return <CommonMessage message={i18n.t('screens:loyaltyScreen.loyaltyDisabled')} />;
        } else {
            return (
                <React.Fragment>
                    {this.state.modal && this.renderModal()}
                    <AvForm id="loyaltyForm" onValidSubmit={this.toggleLoyaltyUpdateModal}>
                        <Row>
                            <Col md={6} sm={12}>
                                <div style={containerStyle}>
                                    <Row>{this.renderHeading(
                                        "settings_applications",
                                        i18n.t('screens:restaurantsMainContainer.general'))}</Row>
                                    <div style={{ marginLeft: 15 }}>
                                        {this.renderLoyaltyNameAndDescription()}
                                        {this.renderActiveLoyalty()}
                                    </div>
                                </div>
                                <div style={containerStyle}>
                                    <Row>{this.renderHeading(
                                        "date_range",
                                        i18n.t('screens:loyaltyScreen.validity'))}</Row>
                                    <div style={{ marginLeft: 15 }}>
                                        {this.renderDatePickers()}
                                    </div>
                                </div>
                                <div style={containerStyle}>
                                    <Row>{this.renderHeading("money",
                                        i18n.t('screens:loyaltyScreen.condition'))}</Row>
                                    <div style={{ marginLeft: 15 }}>
                                        {this.renderAmountAndValue()}
                                    </div>
                                </div>
                            </Col>
                            <Col md={6} sm={12}>
                                <div style={containerStyle}>
                                    <Row>{this.renderHeading("photo_camera",
                                        i18n.t('screens:loyaltyScreen.image'))}</Row>
                                    <div style={{ marginLeft: 15 }}>
                                        {this.renderLoyaltyImage()}
                                    </div>
                                </div>
                                <div style={containerStyle}>
                                    <Row>{this.renderHeading("emoji_events",
                                        i18n.t('screens:loyaltyScreen.reward'))}</Row>
                                    <div style={{ marginLeft: 15 }}>
                                        {this.renderPromoCodeValidity()}
                                    </div>
                                </div>
                                <div style={containerStyle}>
                                    <Row>{this.renderHeading("shopping_cart",
                                        i18n.t('screens:loyaltyScreen.orderOptions'))}</Row>
                                    <div style={{ marginLeft: 15 }}>
                                        {this.renderDeliveryOptions()}
                                    </div>
                                </div>

                            </Col>
                        </Row>
                        <Row className={"justify-content-end"}>
                            <Button 
                                style={buttons} 
                                type="submit"
                                color="primary"
                                disabled={!this.state.isMenuuAdminOrMasterAdmin}>
                                <MaterialIcon icon="save" color="#fff" size={18} />
                                    <span style={spaceBetween}> 
                                        {i18n.t('common:buttons.save')}
                                    </span>
                            </Button>
                            {this.state.loyaltyForm.id !== -1 ?
                                <Button 
                                    style={buttons} 
                                    type="button" 
                                    color="outline-primary"
                                    onClick={this.toggleLoyaltyDeleteModal}
                                    disabled={!this.state.isMenuuAdminOrMasterAdmin}>
                                        {i18n.t('common:buttons.delete')}
                                </Button>
                                : null}
                        </Row>
                    </AvForm>
                    <LoyaltyUsers
                        restaurantId={this.props.match.params.id} />
                    {
                        this.state.cropLoyaltyImageModalOpened ?
                            <CropImageModal
                                isOpen={this.state.cropLoyaltyImageModalOpened}
                                onClickSave={this.onCropLoyaltyImageUpload}
                                toggle={this.toggleLoyaltyImageCropModal}
                                modalClass='cropPromotionImage'
                                crop={{
                                    image: this.state.loyaltyImageBase64,
                                    crop: { x: 0, y: 0 },
                                    zoom: 1,
                                    cropSize: { width: 300, height: 225 },
                                    croppedAreaPixels: null,
                                }}
                            /> : null
                    }
                </React.Fragment>
            );
        }
    }
}

const mapStateToProps = (state) => {
    return {
        supportedOrderTypes: state.serviceSettingsGeneral.orderTypes,
        loyalty: state.loyalty,
        restaurant: state.restaurant,
        loyaltyErrorResponse: state.loyaltyErrorResponse,
        user: state.user
    }
};

export default connect(mapStateToProps, {
    loadRestaurantSettings,
    getLoyalty,
    uploadPromotionImage,
    saveLoyalty,
    deleteLoyalty,
    deleteLoyaltyImage,
    dispatchErrorMessage
})(LoyaltyScreen);

let styles = {
    buttons: {
        margin: '10px 5px'
    },
    containerStyle: {
        marginTop: 10,
        marginLeft: 15,
        marginBottom: 25,
        backgroundColor: '#fafafa',
        borderLeft: '1px solid #0288d1',
        paddingTop: 10,
        paddingLeft: 10,
        paddingRight: 20,
        paddingBottom: 10
    },
    screenHeading: {
        display: 'flex',
        borderBottom: '1px solid rgb(222, 226, 230)',
        marginBottom: 20,
        marginLeft: 15,
        paddingLeft: 0,
        color: '#0288d1',
        width: 299
    },
    textArea: {
        height: 75,
        resize: 'none'
    },
    priceInput: {
        display: 'flex',
        flexWrap: 'wrap'
    },
    priceInputField: {
        width: 'calc(100% - 20px)'
    },
    currencyTypeStyle: {
        alignSelf: 'center',
        paddingLeft: 10,
        width: 20,
        margin: 0
    },
    figure: {
        position: 'relative',
        margin: '0 auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 225,
        width: 300,
        overflow: 'hidden',
        background: '#F0F0F0'
    },
    checkboxesContainer: {
        marginBottom: 20
    },
    checkboxesLabel: {
        marginRight: 5
    },
    fieldLabel: {
        whiteSpace: 'nowrap'
    },
    spaceBetween: {
        paddingLeft: 4
    },
    deleteButton: {
        position: 'absolute',
        top: '10px',
        right: '10px',
        cursor: 'pointer',
        zIndex: 2
    },
    restaurantsHeading: {
        borderBottom: "1px solid #dee2e6"
    },
    radioButtonsContainer: {
        marginBottom: 8
    },
    radioBtnLabel: {
        marginRight: 10
    }
};


// WEBPACK FOOTER //
// ./src/components/restaurants/loyalty/LoyaltyScreen.js